// eslint-disable-next-line import/no-anonymous-default-export
export default {
  //live
  BASE_URL: "https://api.cars53.in/v1",
  IMAGE_URL: "https://api.cars53.in",
  //local
  // BASE_URL: "http://localhost:5500/v1",
  // IMAGE_URL: "http://localhost:5500",
};
